import { useServices } from '@packages/shared/core/common/hooks';
import { useLocation } from '@packages/shared/core/location/hooks';
import { LocationCountry } from '@packages/shared/core/location/entities';
import { ConsentSettingsClickedEvent } from '../analytics/events';

export const useCookieConsent = () => {
  const { cookieConsentService, analyticsService } = useServices();
  const { country } = useLocation();

  const openConsentSettings = () => {
    cookieConsentService.toggleReconsent();
    analyticsService.track(new ConsentSettingsClickedEvent());
  };

  const consentSettingsButtonText =
    country === LocationCountry.US ? 'Do Not Sell or Share My Personal Information' : 'Consent Settings';

  return {
    openConsentSettings,
    consentSettingsButtonText,
  };
};
